import { render, staticRenderFns } from "./custom-dropdown.vue?vue&type=template&id=805650de&scoped=true&"
import script from "./custom-dropdown.vue?vue&type=script&lang=js&"
export * from "./custom-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./custom-dropdown.vue?vue&type=style&index=0&id=805650de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805650de",
  null
  
)

export default component.exports